
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/assignments/create",
      function () {
        return require("private-next-pages/assignments/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/assignments/create"])
      });
    }
  